/* APIRoutes
* Use create/retrieve/update/delete keywords for api prop name and follow the module screen hierarchy.
* if same api is used for multiple operations, define it once with the prop name in short form
*  (e.g cu, cd,cud, crud)
*/

export const APIRoutes = {
    productReceipts: {
        parkedReciepts: {
            retrieve: 'ProductReceipts/RetrieveParkedReceipts',
        },
        FreightDetails: {
            retrieve: 'ProductReceipts/ProductReceipt/:ProductReceiptId/FreightDetails',
            update: 'ProductReceipts/ProductReceipt/:ProductReceiptId/FreightDetails',
        },
        context: {
            action: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Context',
        },
        productReceipt: {
            process: 'ProductReceipts/ProductReceipt/:ProductReceiptId/ProcessReceipt',
            receiptConfirmation: 'ProductReceipts/ProductReceipt/:ProductReceiptId/ReceiptConfirmation',
            overChargeNotice: {
                retrieve: 'ProductReceipts/ProductReceipt/:ProductReceiptId/OverchargeNotice'
            },
            lines: {
                retrieve: 'ProductReceipts/ProductReceipt/:ProductReceiptId/ReceiptLines',
                delete: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber',
                update: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber/UpdateGridLine',
                calculate: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber/CalculateGridLine',
            },
            details: {
                action: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Details'
            },
            park: {
                action: 'ProductReceipts/ProductReceipt/:ProductReceiptId/ParkReceipt'
            },
            lineDetails: {
                retrieve: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber/Details',
                calculate: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber/CalculateLineDetails',
                update: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Line/:LineNumber/UpdateLineDetails',
                initialBin: 'Product/:ProductId/Warehouse/:Warehouse/InitialiseInboundLotSerial'
            },
            load: {
                purchaseOrder: 'ProductReceipts/ProductReceipt/:ProductReceiptId/PurchaseOrder/:PurchaseOrder/Load'
            },
            cancel: {
                delete: 'ProductReceipts/ProductReceipt/:ProductReceiptId/Cancel',
            },
        },
        summary: {
            retrieve: 'ProductReceipts/ProductReceipt/:ProductReceipt/Summary'
        },
        fastEntry: {
            calculateFastLine: 'ProductReceipts/ProductReceipt/:ProductReceiptId/CalculateFastLine',
            createFastLine: 'ProductReceipts/ProductReceipt/:ProductReceiptId/CreateFastLine',
        },

    }
};
